import App from './App'
import Shape from './Shape'
import Current from './Current'
import BadgeList from './BadgeList'
import Navigation from './Navigation'

export default {
  App,
  Shape,
  Current,
  BadgeList,
  Navigation
}
